import { networkCall } from "../../../../../util/network-call/network-call";

export const CompanyAdminUserListLoader = async () => {

    const response = await networkCall('/users');

    return { response };

};